import { apiCallWrapper } from "~/utils/apiCallWrapper";
import { shouldSkipApiRequestForRobot } from "~/utils";

export default (axios, config) => ({
  // Где вызывается: клиент и сервер.
  getCatalog(data, reset = false) {
    return apiCallWrapper(
      axios,
      `${config.API_SERVER_URL}/catalogServer/getCatalog`,
      {
        data,
        reset,
      },
      "post",
    );
  },
  // Где вызывается: сервер.
  getServicesList(domain, reset = false) {
    return apiCallWrapper(
      axios,
      `${config.API_SERVER_URL}/catalogServer/getServicesNew`,
      {
        type: "list",
        domain,
        reset,
      },
    );
  },
  // Где вызывается: клиент.
  getServicesListCard(domain, marka, reset = false) {
    // Блок "Услуги" на карточке товара боту не нужен, а запрос тяжёлый: роут
    // тянет весь массив услуг и фильтрует его в памяти на каждый вызов. При
    // обходе тысяч карточек это давало основную массу событий в GlitchTip
    // (Baiduspider-render → 503, bingbot → 403) и лишнюю нагрузку на Bitrix.
    if (shouldSkipApiRequestForRobot()) {
      return null;
    }
    return apiCallWrapper(
      axios,
      `${config.API_SERVER_URL}/catalogServer/getServicesNew`,
      {
        type: "listCard",
        domain,
        marka,
        reset,
      },
    );
  },
  // Где вызывается: клиент и сервер.
  getDomains(reset = false) {
    // Хедер дёргает домены на каждой странице, пока у посетителя не определён
    // город. У краулера куки между страницами не живут, поэтому город пуст
    // всегда — и обход каталога превращается в поток запросов (в GlitchTip это
    // был весь поток 503 по /api/catalogServer/getDomains от Baiduspider).
    // На сервере navigator отсутствует и проверка вернёт false — SSR не задет.
    if (shouldSkipApiRequestForRobot()) {
      return null;
    }
    return apiCallWrapper(
      axios,
      `${config.API_SERVER_URL}/catalogServer/getDomains`,
      {
        reset,
      },
    );
  },
  // Где вызывается: клиент и сервер.
  getBrands(reset = false) {
    return apiCallWrapper(
      axios,
      `${config.API_SERVER_URL}/catalogServer/getBrands`,
      {
        reset,
      },
    );
  },
  // Где вызывается: не используется.
  getProduct(code, host, reset = false) {
    return apiCallWrapper(
      axios,
      `${config.API_SERVER_URL}/catalogServer/getProduct`,
      {
        code,
        host,
        reset,
      },
    );
  },
  // Где вызывается: клиент и сервер.
  getCatalogBanners(reset = false) {
    return apiCallWrapper(
      axios,
      `${config.API_SERVER_URL}/catalogServer/getCatalogBanners`,
      { reset },
    );
  },
  // Где вызывается: клиент.
  getClientComments(page, marka, model, kuzov, host, reset = false) {
    if (shouldSkipApiRequestForRobot()) {
      return null;
    }
    return apiCallWrapper(
      axios,
      `${config.API_SERVER_URL}/catalogServer/getClientComments`,
      { page, marka, model, kuzov, host, reset },
    );
  },
  // Где вызывается: клиент и сервер.
  getBaltexSections(reset = false) {
    return apiCallWrapper(
      axios,
      `${config.API_SERVER_URL}/catalogServer/getBaltexSections`,
      { reset },
    );
  },
  // Где вызывается: клиент.
  getMarks(isBaltex, mark = "", model = "", kuzov = "", reset = false) {
    return apiCallWrapper(
      axios,
      `${config.API_SERVER_URL}/catalogServer/getMarks`,
      {
        mark,
        model,
        kuzov,
        isBaltex,
        reset,
      },
    );
  },
  // Где вызывается: не используется.
  getInstallMarks(mark, reset = false) {
    return apiCallWrapper(
      axios,
      `${config.API_SERVER_URL}/catalogServer/getInstallMarks`,
      { mark, reset },
    );
  },
  // Где вызывается: клиент и сервер.
  getProductDelivery(
    productIds,
    destinationWarehouses,
    time = "",
    weekday = "",
    reset = false,
  ) {
    return apiCallWrapper(
      axios,
      `${config.API_SERVER_URL}/catalogServer/getProductDeliveryNew`,
      {
        productIds: productIds.join(","),
        destinationWarehouses: destinationWarehouses.join(","),
        time,
        weekday,
        reset,
      },
    );
  },
  // Где вызывается: сервер.
  getMainPortfolio(host, reset = false) {
    return apiCallWrapper(
      axios,
      `${config.API_SERVER_URL}/catalogServer/getMainPortfolio/`,
      {
        host,
        reset,
      },
    );
  },
  // Где вызывается: клиент.
  sentFeedback(data) {
    return apiCallWrapper(
      axios,
      `${config.API_SERVER_URL}/catalogServer/sentFeedback/`,
      data,
      "post",
    );
  },
  // Где вызывается: клиент и сервер.
  getProductReviewsAndQuestionsByIds(
    ids,
    host,
    reset = false,
    source = "client",
  ) {
    if (shouldSkipApiRequestForRobot()) {
      return null;
    }
    return apiCallWrapper(
      axios,
      `${config.API_SERVER_URL}/catalogServer/getProductReviewsAndQuestionsByIds`,
      {
        ids: Array.isArray(ids) ? ids.join(",") : String(ids),
        host,
        reset,
        source,
      },
    );
  },
  /**
   * Где вызывается: клиент.
   * @param {import('../types/cart').GetCartProductsItem[]} items
   * @param {boolean} [reset]
   */
  getCartProducts(items, reset = false) {
    if (!items?.length) {
      return [];
    }
    return apiCallWrapper(
      axios,
      `${config.API_SERVER_URL}/catalogServer/getCartProducts`,
      { items, reset },
      "post",
    );
  },
  // Где вызывается: клиент.
  getProductById(id, reset = false) {
    return apiCallWrapper(
      axios,
      `${config.API_SERVER_URL}/catalogServer/getProductById`,
      {
        id,
        reset,
      },
    );
  },
  /**
   * Настройки универсальной отбивки (тексты, время работы), редактируемые в
   * панели. Читаются серверным роутом `/api/form-success-reply`.
   */
  getFormSuccessReply(reset = false) {
    return apiCallWrapper(
      axios,
      `${config.API_SERVER_URL}/form-success-reply`,
      { reset },
      "get",
    );
  },
});
